import { Navigate } from "react-router-dom";
import { useProfile } from "@/context/ProfileContext";
import { Loader2 } from "lucide-react";

export const PageLoader = () => (
  <div className="grid min-h-[50vh] place-items-center" data-testid="page-loader">
    <Loader2 className="h-8 w-8 animate-spin text-nw-red" />
  </div>
);

// Requires a signed-in user who has completed onboarding.
export const RequireProfile = ({ children }) => {
  const { loading, isSignedIn, onboarded } = useProfile();
  if (loading) return <PageLoader />;
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  if (!onboarded) return <Navigate to="/onboarding" replace />;
  return children;
};
